import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import messages from '../../utils/translationMessages';
import PropTypes from 'prop-types';
import './styles.css';

class ViewCarouselPhotos extends PureComponent {

  render () {
    const { intl: { formatMessage } } = this.props;
    const { images } = this.props;
    return (
      <div className="view-photos" onClick={() => {this.props.openCarouselModal(0);}}>{formatMessage(messages.viewCarouselPhotos.view)} {images.length} {images.length > 1 ?
        formatMessage(messages.viewCarouselPhotos.photos)  :
        formatMessage(messages.viewCarouselPhotos.photo) }</div>
    );
  }
}

ViewCarouselPhotos.propTypes = {
  images: PropTypes.array,
  openCarouselModal: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired
};

export default (injectIntl(ViewCarouselPhotos));
